<section>
  <!--START NEW HERO-->
  <div class="enableall_banner">
    <div class="row justify-content-between">
      <div class="col-12 col-md-5">
        <h1> Step into Spring<br> in style<span class="dot-text">.</span></h1>
          <p class="mt-5">
            Refresh your wardrobe and more this season. Enjoy free standard delivery on all orders over £40 with code
            EASTER40.
          </p>

          <button class="ea-button ea-button-primary mt-5 mb-4"
            [routerLink]="['/category/0/', '6628c062b1185d00082cf032']">
            Shop clothing
          </button>        
      </div>

      <div class="col-12 col-md-7">
        <img src="assets/images/home-page/New-hero.jpg" class="mb-4" alt="banner" />
      </div>
    </div>
  </div>
  <!--END NEW HERO-->

</section>

<section>
  <!--START NEW CATEGORIES-->
  <div class="categories-container">
    <div class="row">
      <!--Clothing-->
      <div class="col-6 col-md-4 col-lg-2" [routerLink]="['/category/0/', '6628c062b1185d00082cf032']">
        <div class="category">
          <img src="assets/images/home-page/clothing.svg" alt="Clothing and Shoes" />
        </div>
        <p class="category-title">
          Clothing and Shoes </p>
      </div>

      <!--Jewellery-->
      <div class="col-6 col-md-4 col-lg-2 " [routerLink]="['/category/0/', '6628c06bb1185d00082cf042']">
        <div class="category">
          <img src="assets/images/home-page/jewellery.svg" alt="Jewellery" />
        </div>
        <p class="category-title">
          Jewellery </p>
      </div>

      <!--Home-->
      <div class="col-6 col-md-4 col-lg-2" [routerLink]="['/category/0/', '6628c067b1185d00082cf03a']">
        <div class="category">
          <img src="assets/images/home-page/home.svg" alt="Home and Garden" />
        </div>
        <p class="category-title">
          Home and Garden
        </p>
      </div>

      <!--Toys-->
      <div class="col-6 col-md-4 col-lg-2" [routerLink]="['/category/0/', '6628c06fb1185d00082cf04a']">
        <div class="category">
          <img src="assets/images/home-page/toys.svg" alt="Toys" />
        </div>
        <p class="category-title">
          Toys </p>
      </div>

      <!--Books-->
      <div class="col-6 col-md-4 col-lg-2" [routerLink]="['/category/0/', '6628c04fb1185d00082cf02a']">
        <div class="category">
          <img src="assets/images/home-page/books.svg" alt="Books" />
        </div>
        <p class="category-title">
          Books </p>
      </div>

      <!-- Video -->
      <div class="col-6 col-md-4 col-lg-2" [routerLink]="['/category/0/', '6628c073b1185d00082cf052']">
        <div class="category">
          <img src="assets/images/home-page/game.svg" alt="Video Gaming" />
        </div>
        <p class="category-title">
          Video Gaming </p>
      </div>
    </div>

  </div>
  <!--END NEW CATEGORIES-->
</section>

<section>
  <!--START NEW PRODUCTS-->
  <div class="products-container">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="product" [routerLink]="['/category/0/', '6628c067b1185d00082cf03a']">
          <img src="assets/images/home-page/homeCategory.jpg" alt="home Category">
          <div class="category-desc">
            <p>Home and garden essentials</p>
            <span>
              Explore Home and Garden
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="product" [routerLink]="['/category/0/', '6628c06fb1185d00082cf04a']">
          <img src="assets/images/home-page/Desktop-Toys-and-Games.png" alt="Toys and Games">
          <div class="category-desc">
            <p>Timeless toys and fresh finds​</p>
            <span>
              Explore Toys and Games
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--END NEW PRODUCTS-->
</section>